import {
  PhoneInput as BasePhoneInput,
  type PhoneInputProps,
} from "@volca/ui/components/ui/phone-input";
import { useEnv } from "@/core/env";

// @volca/ui's PhoneInput, with the test-number hint on outside production.
export const PhoneInput = (props: PhoneInputProps) => {
  const { appEnv } = useEnv();
  return <BasePhoneInput {...props} testNumberHint={appEnv !== "production"} />;
};
